// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"324":"f4306706","332":"40a5b86e"}[chunkId] + ".css";
};